import React from "react";

const Service = () => {
    return(
        <>
            
   {/* <!-- services start --> */}
   <div class="container text center my-5">
       <h2 class="text-dark text-center">SERVICES</h2>
       <hr class="w-25 mx-auto"/>
       <p class="text-center">what we really know how</p>

        <div class="row">
            <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12">
                <div class="text-center">
                    <figure>
                        <i class="fa-3x fab fa-android"></i>
                    </figure>
                    <div class="">
                        <h5 class="text-dark">App Development</h5>
                        <div class="">
                            <p>
                                Android Developed Graphic User Interface
                            </p>

                        </div>
                    </div>
                </div>
                


            </div>
            <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12">
                <div class="text-center">
                    <figure>
                    <i class="fa-3x fas fa-file-code"></i>
                    </figure>
                    <div class="">
                        <h5 class="text-dark">Web Development</h5>
                        <div class="">
                            <p>
                                Frontent and Backcant create using framework 
                            </p>

                        </div>
                    </div>
                </div>
                


            </div>
            <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12">
                <div class="text-center">
                    <figure>
                        <i class="fa-3x fab fa-grav"></i>
                    </figure>
                    <div class="">
                        <h5 class="text-dark">GUI Development</h5>
                        <div class="">
                            <p>
                                Graphical Design use for user easily
                            </p>

                        </div>
                    </div>
                </div>
                


            </div>
            <div class="col-xxl-3 col-lg-3 col-md-6 col-sm-12">
                <div class="text-center">
                    <figure>
                         <i class="fa-3x fas fa-blog"></i>
                    </figure>
                    <div class="">
                        <h5 class="text-dark">Web Design</h5>
                        <div class="">
                            <p>
                                Awesome Web design from html, css, bootstrap.
                            </p>

                        </div>
                    </div>
                </div>
                


            </div>

            
        <div class="text-center mx-auto">
            {/* <button class="btn btn-dark">Click Now</button> */}
        </div>

        </div>
   </div>
   {/* <!-- services end  --> */}

        </>
    );
};

export default Service;